module.exports = __webpack_public_path__ + "img/社保福利@2x.16fcbfad.png";